const CODE_MESSAGES = {
  'auth/invalid-credential': 'Incorrect email or password.',
  'auth/wrong-password': 'Incorrect email or password.',
  'auth/user-not-found': 'Incorrect email or password.',
  'auth/email-already-in-use': 'An account with this email already exists. Please sign in or continue your saved registration.',
  'auth/invalid-email': 'Enter a valid email address.',
  'auth/weak-password': 'Choose a stronger password with at least 8 characters.',
  'auth/too-many-requests': 'Too many attempts. Please try again later.',
  'auth/network-request-failed': 'Network connection failed. Check your internet connection and try again.',
  'auth/operation-not-allowed': 'Email/password authentication is disabled in Firebase Authentication.',
  'auth/unauthorized-domain': 'This website domain is not authorized in Firebase Authentication settings.',
  'auth/unauthorized-continue-uri': 'The verification return URL is not authorized in Firebase Authentication settings.',
  'auth/missing-continue-uri': 'The Firebase verification return URL is missing.',

  'functions/unauthenticated': 'Please sign in again to continue.',
  'functions/permission-denied': 'You do not have permission to perform this action.',
  'functions/internal': 'The service could not complete your request. Please try again.',
  'functions/unavailable': 'This service is temporarily unavailable. Please try again.',
  'functions/deadline-exceeded': 'The request took too long. Please try again.',
  'permission-denied': 'You do not have permission to perform this action.',
};
const TECHNICAL = /(firebase|firestore|functions\/|auth\/|permission-denied|internal error|failed-precondition|cloud function|network-request-failed)/i;
export const friendlyError = (error, fallback = 'Something went wrong. Please try again.') => {
  const code = String(error?.code || '').replace(/^firebase:/i, '');
  if (CODE_MESSAGES[code]) return CODE_MESSAGES[code];
  const message = String(error?.message || '').trim();
  if (!message || TECHNICAL.test(message)) return fallback;
  return message.length > 220 ? fallback : message;
};
